<template>
    <SectionContentLayout>
        <template #content>
            <div class="push-center">
                <div class="dashboard-header">
                    <i class="far fa-address-card"></i>
                    <p><strong>{{Language.say('contacts.title')}}</strong></p>
                    <div v-if="contacts_selection.count" >
                        <p>
                            <strong>{{contacts_selection.count}}</strong>
                            {{Language.say('contacts.selected_contacts')}}
                        </p>
                    </div>
                </div>

                <div class="dashboard-actions">
                    <ContactsContextSelectedActions v-if="contacts_selection.count"
                        :contacts_view='contacts_view'
                        :contacts_selection='contacts_selection'
                        :webmail_view="webmail_view"
                    />
                    <ContactsContextActions v-else/>
                </div>
            </div>
        </template>
    </SectionContentLayout>
</template>

<script setup>
  import { defineProps }                from 'vue';
  import ContactsContextActions         from '../Partials/ContactsContextActions.vue';
  import ContactsContextSelectedActions from '../Partials/ContactsContextSelectedActions.vue';
  import SectionContentLayout           from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import Language                       from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    contacts_selection : {},
    contacts_view      : {},
    webmail_view       : {},
  })
</script>
